import { io } from "socket.io-client";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function createLiveSocket() {
  return io(BACKEND, {
    path: "/api/socket.io",
    transports: ["websocket", "polling"],
    autoConnect: true,
  });
}

// Lien de vote partagé au public
export function voteLink(code) {
  const origin = typeof window !== "undefined" ? window.location.origin : BACKEND;
  return `${origin}/?live=${code}`;
}
